import IconComponent from "icons/IconComponent";

import Receipt from "./receipt.svg";

export default (Receipt as any) as IconComponent;
